<template>
    <div>
        <b><span>
            Direccion del viento actual: {{ lastAddress }} °
        </span></b>
        <br>
        <span>
            Datos recuperados (Jornada diurna): {{ daytimeDataRetrieved }} %
        </span>
        <br>
        <span>
            Datos recuperados (Jornada nocturna): {{ nightDataRetrieved }} %
        </span>
        <br>
        <span>
            Última transmisión: {{ ultimaTransmision }}
        </span>
        <GraphRose 
            :data-series="directions" 
            chart-title="Dirección del viento (últimas 24 horas)" 
            :id-div="7+index" 
        />
    </div>
</template>

<script>
    import GraphRose from '../Graphs/GraphRose.vue';

    export default{
        name: 'Direction',

        components:{
            GraphRose
        },

        props:{
            charts: [],
            index: Number
        },

        data() {
            return{
                lastAddress: 0,
                ultimaTransmision: '',
                daytimeDataRetrieved: 0,
                nightDataRetrieved: 0,
                directions: {}
            }
        },

        created(){
            this.Get_Directions();
        },

        methods: {
            /*
            * Este array es para constuir una gráfica de barras.
            * Se suma 1 cada vez que la dirección apunta a X dirección
            * según la guía de direcciones de equivalencias_dir_viento.png 
            * que se encuentra en @/assets/images
            */
            Get_Directions() {
                const diurno = [['N',0],['NNE',0],['NE',0],['ENE',0],['E',0],
                                ['ESE',0],['SE',0],['SSE',0],['S',0],['SSO',0],
                                ['SO',0],['OSO',0],['O',0],['ONO',0],['NO',0],['NNO',0]];
                const nocturno = [['N',0],['NNE',0],['NE',0],['ENE',0],['E',0],
                                    ['ESE',0],['SE',0],['SSE',0],['S',0],['SSO',0],
                                    ['SO',0],['OSO',0],['O',0],['ONO',0],['NO',0],['NNO',0]];
                let totalDiurnos = 0;
                let totalNocturnos = 0;
                let recuperadosDiurno = 0;
                let recuperadosNocturno = 0;

                /*
                * Se dividen en datos diurnos y en datos nocturnos
                */

                for(var i in this.charts){
                    let direccion = parseFloat(this.charts[i].windDirection);

                    let hora = this.charts[i].time;

                    if(hora >= '18:00:00' || hora < '06:00:00'){
                        totalNocturnos ++;
                        if(!isNaN(direccion)){
                            if(direccion > 349 && direccion <= 11){
                                nocturno[0][1]++;
                            }else if(direccion > 326 && direccion <= 349){
                                nocturno[1][1]++;
                            }else if(direccion > 304 && direccion <= 326){
                                nocturno[2][1]++;
                            }else if(direccion > 281 && direccion <= 304){
                                nocturno[3][1]++;
                            }else if(direccion > 259 && direccion <= 381){
                                nocturno[4][1]++;
                            }else if(direccion > 236 && direccion <= 259){
                                nocturno[5][1]++;
                            }else if(direccion > 214 && direccion <= 236){
                                nocturno[6][1]++;
                            }else if(direccion > 191 && direccion <= 214){
                                nocturno[7][1]++;
                            }else if(direccion > 169 && direccion <= 191){
                                nocturno[8][1]++;
                            }else if(direccion > 146 && direccion <= 169){
                                nocturno[9][1]++;
                            }else if(direccion > 124 && direccion <= 146){
                                nocturno[10][1]++;
                            }else if(direccion > 101 && direccion <= 124){
                                nocturno[11][1]++;
                            }else if(direccion > 79 && direccion <= 101){
                                nocturno[12][1]++;
                            }else if(direccion > 56 && direccion <= 79){
                                nocturno[13][1]++;
                            }else if(direccion > 34 && direccion <= 56){
                                nocturno[14][1]++;
                            }else if(direccion > 11 && direccion <= 34){
                                nocturno[15][1]++;
                            }
                            recuperadosNocturno ++;
                        }
                    }else{
                        totalDiurnos ++;
                        if(!isNaN(direccion)){
                            if(direccion > 349 && direccion <= 11){
                                diurno[0][1]++;
                            }else if(direccion > 326 && direccion <= 349){
                                diurno[1][1]++;
                            }else if(direccion > 304 && direccion <= 326){
                                diurno[2][1]++;
                            }else if(direccion > 281 && direccion <= 304){
                                diurno[3][1]++;
                            }else if(direccion > 259 && direccion <= 381){
                                diurno[4][1]++;
                            }else if(direccion > 236 && direccion <= 259){
                                diurno[5][1]++;
                            }else if(direccion > 214 && direccion <= 236){
                                diurno[6][1]++;
                            }else if(direccion > 191 && direccion <= 214){
                                diurno[7][1]++;
                            }else if(direccion > 169 && direccion <= 191){
                                diurno[8][1]++;
                            }else if(direccion > 146 && direccion <= 169){
                                diurno[9][1]++;
                            }else if(direccion > 124 && direccion <= 146){
                                diurno[10][1]++;
                            }else if(direccion > 101 && direccion <= 124){
                                diurno[11][1]++;
                            }else if(direccion > 79 && direccion <= 101){
                                diurno[12][1]++;
                            }else if(direccion > 56 && direccion <= 79){
                                diurno[13][1]++;
                            }else if(direccion > 34 && direccion <= 56){
                                diurno[14][1]++;
                            }else if(direccion > 11 && direccion <= 34){
                                diurno[15][1]++;
                            }
                            recuperadosDiurno ++;
                        }
                    }
                }

                for(i in this.charts){
                    let direccion = parseFloat(this.charts[i].windDirection);
                    if(!isNaN(direccion)){
                        this.ultimaTransmision = this.charts[i].date+' '+this.charts[i].time
                        this.lastAddress = direccion;
                    }
                }

                if(totalDiurnos > 0){
                    this.daytimeDataRetrieved = (recuperadosDiurno*100/totalDiurnos).toFixed(1);
                }
                
                if(totalNocturnos > 0){
                    this.nightDataRetrieved = (recuperadosNocturno*100/totalNocturnos).toFixed(1);
                }

                this.directions = {
                    diurno, 
                    nocturno
                };
            }
        }
    };
</script>